import { Body, Container, Footer, Table, TableTitle } from './styles';

export interface ISummarizedByFlagData {
  paymentMethod: string | undefined;
  data: {
    [key: string]: number;
  };
  totalLiquido: number | undefined;
  totalBruto: number | undefined;
}

interface ISummarizedByFlagDataTableProps {
  summarizedByFlagData: ISummarizedByFlagData[];
}

export const SummarizedByFlagDataTable = ({
  summarizedByFlagData,
}: ISummarizedByFlagDataTableProps) => {
  return (
    <Container>
      <TableTitle>Resumido por Bandeira</TableTitle>
      <Body>
        {summarizedByFlagData?.map((table: ISummarizedByFlagData) => (
          <Table key={table.paymentMethod}>
            <h6>{table.paymentMethod}</h6>
            {Object.keys(table?.data)?.map((key, index) => (
              <div key={key}>
                <p>{key}</p>
                <p>
                  {Object.values(table?.data)[index].toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  })}
                </p>
              </div>
            ))}
            <div>
              <p>Total Bruto: </p>
              <p>
                {table.totalBruto?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
            <div>
              <p>Total Líquido: </p>
              <p>
                {table.totalLiquido?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
          </Table>
        ))}
      </Body>
      <Footer>
        <p>Total Bruto:</p>
        <p>
          {summarizedByFlagData
            .reduce(
              (acc, transaction) =>
                transaction.totalBruto ? (acc += transaction?.totalBruto) : acc,
              0
            )
            .toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            })}
        </p>

        <p>Total Líquido:</p>
        <p>
          {summarizedByFlagData
            .reduce(
              (acc, transaction) =>
                transaction.totalLiquido
                  ? (acc += transaction?.totalLiquido)
                  : acc,
              0
            )
            .toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            })}
        </p>
      </Footer>
    </Container>
  );
};
